import React from 'react'
import  './DescriptionBox.css'
const DescriptionBox = () => {
  return (
    <div className='descriptionbox'>
        <div className="descriptionbox-navigator">
            <div className="descriptionbox-nav-box">
                Description
            </div>
            <div className="descriptionbox-nav-box fade">
                Reviews (122)
            </div>
        </div>
        <div className="descriptionbox-description">
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Officiis ipsum, natus eum repellendus perspiciatis id perferendis fuga, quia deserunt aspernatur sed illo numquam culpa. Ipsam itaque voluptates minus suscipit soluta.</p>

            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam expedita hic, est adipisci odio accusantium asperiores, quo eius dolore sit at quos? Mollitia modi nobis, debitis dolore laudantium culpa recusandae.</p>
        </div>
      
    </div>
  )
}

export default DescriptionBox
